import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { Subject, Observable } from 'rxjs';
import { ApiRequestsService } from './api-requests.service';
import { CanActivate, Router } from '@angular/router';
import { NotificationsService } from './notifications.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements CanActivate {

  user: User;
  userSubject = new Subject<User>();

  constructor(private apiRequestsService: ApiRequestsService,
              private notificationsService: NotificationsService,
              private router: Router) { }

  emitUser() {
    // notify subscriptions and provide them with updated user data
    console.log('CALL AuthService.emitUser()');
    this.userSubject.next(this.user);
  }

  async signInUser(username: string, password: string) {
    try {
      // Use credentials to retrieve a token
      await this.apiRequestsService.startSession(username, password);

      // Access user infos
      const data: any = await this.apiRequestsService.get('user-infos');

      //Creation of a user and initialization and emit
      if (!this.user) {this.user = new User()}
      this.user.initFromData(data);
      this.emitUser();

      this.notificationsService.notify('auth/sign-in-ok');

      this.router.navigate(['/tools']);
    }
    catch(e) {
      this.notificationsService.notify('auth/sign-in-ko');
    }
  }

  async signOutUser() {
    try {
      // Destroy token both local and in database
      await this.apiRequestsService.destroySession();

      // Deletion of user and emit
      this.user = undefined;
      this.emitUser();

      this.notificationsService.notify('auth/sign-out-ok');

      this.router.navigate(['/']);
    }
    catch(e) {
      this.notificationsService.notify('auth/sign-out-ko');
    }
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    // If no token, the user must sign in
    if (!this.apiRequestsService.hasToken()) {
      this.router.navigate(['/sign-in']);
      return false;
    }

    // If a token exists, its validity is checked
    return this.apiRequestsService.checkToken();
  }

}
